module.exports = __webpack_public_path__ + "img/bot.78ad26e3.gif";